import { Exclude } from 'class-transformer';

export class ConveyanceSoaAttachmentResultDto {
    description: string;
    incomingDocument: boolean;
    attachmentType: string;
    fileId: number;
    fileName: string;
    downloadUrl: string;

    // transient variable
    @Exclude()
    fileIcon: string;
}
